const e = {
  add: "Add",
  cancel: "Cancel",
  clear: "Clear",
  confirm: "Confirm",
  delete: "Delete",
  redo: "Redo",
  save: "Save",
  saveAs: "Save as",
  undo: "Undo"
}, a = {
  clear: "Clear",
  confirm: "Confirm",
  datePlaceholder: "Select Date",
  datetimePlaceholder: "Select Date and Time",
  endDatePlaceholder: "End Date",
  endDatetimePlaceholder: "End Date and Time",
  endMonthPlaceholder: "End Month",
  monthPlaceholder: "Select Month",
  now: "Now",
  quarterPlaceholder: "Select Quarter",
  selectDate: "Select Date",
  selectTime: "Select Time",
  startDatePlaceholder: "Start Date",
  startDatetimePlaceholder: "Start Date and Time",
  startMonthPlaceholder: "Start Month",
  today: "Today",
  weekPlaceholder: "Select Week",
  yearPlaceholder: "Select Year"
}, t = {
  placeholder: "Please Select"
}, o = {
  clear: "Clear",
  negativeText: "Cancel",
  now: "Now",
  placeholder: "Select Time",
  positiveText: "OK"
}, l = {
  placeholder: "Please Input"
}, r = {
  placeholder: "Please Input"
}, n = {
  placeholder: "Start typing..."
}, c = {
  allRows: "All rows",
  default: "Default",
  deleteLayoutDescription: "Are you sure you want to delete this layout?",
  discardChanges: "Discard changes",
  discardLayoutChanges: "Discard layout changes",
  enterLayoutName: "Enter layout name",
  enterRowNumber: "Enter number of rows",
  fieldsSelected: "fields selected",
  freezeColumnDescription: "Freeze the column to the left",
  freezeUptoColumn: "Freeze upto column",
  frozen: "Frozen",
  layoutName: "Layout Name",
  manageColumns: "Manage Columns",
  none: "None",
  reorderRows: "Reorder Rows",
  rowsSelected: "rows selected",
  saveLayoutAs: "Save layout as",
  saveLayoutNew: "Save new layout",
  search: "Search",
  searchColumnsPlaceholder: "Search columns",
  searchFieldsPlaceholder: "Search fields",
  selectAll: "Select all",
  setTableHeight: "Set table height",
  unfreeze: "Unfreeze",
  unsavedChanges: "You have unsaved changes",
  unsavedChangesDescription: "There might be one or more unsaved changes. Do you want to save them?"
}, s = {
  at: "at",
  colorAlreadyUsed: "Choose a different shade or use existing",
  colorNamePlaceholder: "Enter Name",
  customPlaceholder: "{{ Custom }}",
  nameAlreadyUsed: "Please choose a different color name",
  noColorsAdded: "You do not have any colors in this section."
}, d = {
  searchPlaceholder: "Search"
}, i = {
  invalidPastedData: "Invalid pasted data"
}, h = {
  of: "of",
  page: "Page",
  rowsPerPage: "Rows per page"
}, u = {
  failedToUpload: "Failed to upload",
  retry: "Retry",
  clickToUpload: "Click to upload",
  orDragAndDrop: "or drag and drop",
  supportedFileTypes: "Supported file types:"
}, p = {
  global: e,
  DatePicker: a,
  Select: t,
  TimePicker: o,
  Input: l,
  InputNumber: r,
  InputTag: n,
  HLDataTable: c,
  ColorPicker: s,
  InputPhone: d,
  InputOtp: i,
  Pagination: h,
  Upload: u
};
export {
  s as ColorPicker,
  a as DatePicker,
  c as HLDataTable,
  l as Input,
  r as InputNumber,
  i as InputOtp,
  d as InputPhone,
  n as InputTag,
  h as Pagination,
  t as Select,
  o as TimePicker,
  u as Upload,
  p as default,
  e as global
};
